import { bool, func, oneOf } from "prop-types";
import { useTranslation } from "react-i18next";
import { TaskTypes } from "@repo/utils";
import { MenuButton } from "@components";
import { RadioButtonChecked, RadioButtonUnchecked } from "@material-ui/icons";

export const RowTypeButton = ({
  type,
  checked,
  onClick,
}) => {
  const { t } = useTranslation();
  
  return (
    <MenuButton
      onClick={onClick}
      icon={
      checked
        ? <RadioButtonChecked color="primary" />
        : <RadioButtonUnchecked color="primary" />
    }
    >
      {t(`proposal_parts.row_types.${type}`)}
    </MenuButton>
  )
}

RowTypeButton.propTypes = {
  type: oneOf([TaskTypes.FIXED_PRICE, TaskTypes.MATERIAL, TaskTypes.WORKLOAD]).isRequired,
  checked: bool.isRequired,
  onClick: func.isRequired,
}